import React, { useState, useMemo } from 'react';
import SearchBar from '../SearchBar';
import IndexSortList, { IndexSortListItem } from '../IndexSortList';
import './index.scss';
import { isEmpty } from '@/utils';

export interface SearchableIndexListProps {
  data: IndexSortListItem[];
  onItemClick?: (item: IndexSortListItem) => void;
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
  searchBarStyle?: React.CSSProperties;
  listStyle?: React.CSSProperties;
}

const SearchableIndexList: React.FC<SearchableIndexListProps> = ({
  data,
  onItemClick,
  placeholder = '请输入搜索内容',
  className = '',
  style,
  searchBarStyle,
  listStyle
}) => {
  const [searchValue, setSearchValue] = useState<string>('');

  // 根据搜索关键词过滤数据
  const filteredData = useMemo(() => {
    if (!searchValue.trim()) {
      return data;
    }

    const keyword = searchValue.toLowerCase().trim();
    return data.filter((item) => item.label.toLowerCase().includes(keyword));
  }, [data, searchValue]);

  // 处理搜索输入变化
  const handleSearchChange = (value: string) => {
    setSearchValue(value);
  };

  // 处理列表项点击
  const handleItemClick = (item: IndexSortListItem) => {
    if (onItemClick) {
      onItemClick(item);
    }
  };

  // 高亮搜索关键词的渲染函数
  const renderHighlightedLabel = (item: IndexSortListItem) => {
    const keyword = searchValue.trim();
    if (!keyword) {
      return item.label;
    }

    const regex = new RegExp(
      `(${keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
      'gi'
    );
    const parts = item.label.split(regex);

    return (
      <>
        {parts.map((part, index) => {
          if (regex.test(part)) {
            return (
              <span key={index} className="searchable-index-list__highlight">
                {part}
              </span>
            );
          }
          return part;
        })}
      </>
    );
  };

  return (
    <div className={`searchable-index-list ${className}`} style={style}>
      <div className="searchable-index-list__search" style={searchBarStyle}>
        <SearchBar placeholder={placeholder} onChange={handleSearchChange} />
      </div>

      <div className="searchable-index-list__content" style={listStyle}>
        {!isEmpty(filteredData) ? (
          <IndexSortList
            data={filteredData}
            onItemClick={handleItemClick}
            renderLabel={renderHighlightedLabel}
          />
        ) : (
          <div className="searchable-index-list__empty">
            <div className="searchable-index-list__empty-text">
              未找到匹配的结果
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchableIndexList;
